import React from 'react'
import { toPng } from 'html-to-image'

export type GetPngResponse = [
  () => Promise<string | undefined>,
  {
    ref: React.RefObject<HTMLDivElement>
    isLoading: boolean
  }
]

export const useGetPng = (): GetPngResponse => {
  const ref = React.useRef<HTMLDivElement>(null)
  const [isLoading, setIsLoading] = React.useState(false)

  const getPng = async () => {
    if (ref.current) {
      setIsLoading(true)

      return toPng(ref.current).finally(() => {
        setIsLoading(false)
      })
    }
  }

  return [getPng, { ref, isLoading }]
}
